import React, { useState, useEffect } from 'react';
import { motion } from 'framer-motion';
import Typewriter from 'typewriter-effect';

const Splash = ({ value: setLoaders }) => {
  const [entry, setEntry] = useState(true);
  const [showContinue, setShowContinue] = useState(false);
  const [done, setDone] = useState(false);

  useEffect(() => {
    // Initial entry animation
    const entryTimer = setTimeout(() => {
      setEntry(false);
    }, 2500);

    // Show continue button
    const continueTimer = setTimeout(() => {
      setShowContinue(true);
    }, 8000);

    return () => {
      clearTimeout(entryTimer);
      clearTimeout(continueTimer);
    };
  }, []);

  const handleContinue = () => {
    setDone(true);
    setTimeout(() => {
      setLoaders(false, true, false); // Show gateway
    }, 1000);
  };

  const handleSkip = () => {
    setDone(true);
    setTimeout(() => {
      setLoaders(false, true, false); // Skip to portfolio
    }, 700);
  };

  if (entry) {
    return (
      <motion.div
        style={{
          position: 'fixed',
          inset: 0,
          background: 'linear-gradient(135deg, #0f172a 0%, #1e293b 50%, #0f172a 100%)',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          zIndex: 50
        }}
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 0.5 }}
      >
        <motion.div
          initial={{ scale: 0.8, opacity: 0 }}
          animate={{ scale: 1, opacity: 1 }}
          transition={{ duration: 0.8, delay: 0.3 }}
          style={{ textAlign: 'center' }}
        >
          <motion.h1
            style={{
              fontSize: window.innerWidth >= 768 ? '3.75rem' : '2.25rem',
              fontWeight: 'bold',
              color: 'white',
              marginBottom: '16px'
            }}
            initial={{ y: 20 }}
            animate={{ y: 0 }}
            transition={{ duration: 0.6, delay: 0.5 }}
          >
            <span className="gradient-text">Joseph's</span>
            <span style={{ color: '#60a5fa', marginLeft: '8px' }}>Portfolio</span>
          </motion.h1>
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ duration: 0.5, delay: 1 }}
            style={{
              fontSize: '1.25rem',
              color: '#d1d5db'
            }}
          >
            <Typewriter
              options={{
                strings: ['Loading...', 'Preparing experience...', 'Almost ready...'],
                autoStart: true,
                loop: true,
                delay: 100,
                deleteSpeed: 50,
              }}
            />
          </motion.div>
        </motion.div>
      </motion.div>
    );
  }

  return (
    <motion.div
      style={{
        position: 'fixed',
        inset: 0,
        background: 'linear-gradient(135deg, #0f172a 0%, #1e293b 50%, #0f172a 100%)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        zIndex: 50,
        opacity: done ? 0 : 1,
        transition: 'opacity 1s ease'
      }}
      initial={{ opacity: 1 }}
      animate={{ opacity: done ? 0 : 1 }}
    >
      <div style={{
        textAlign: 'center',
        maxWidth: '896px',
        padding: '0 24px'
      }}>
        <motion.h1
          style={{
            fontSize: window.innerWidth >= 1024 ? '3.75rem' : window.innerWidth >= 768 ? '3rem' : '1.875rem',
            fontWeight: 'bold',
            color: 'white',
            marginBottom: '32px'
          }}
          initial={{ y: 30, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          transition={{ duration: 0.8 }}
        >
          <Typewriter
            options={{
              strings: [
                'Hello there 👋🏼',
                'Welcome to my portfolio!',
                'Ready to explore my work?'
              ],
              autoStart: true,
              loop: false,
              delay: 80,
              deleteSpeed: 30,
              cursor: '|'
            }}
          />
        </motion.h1>

        <motion.p
          style={{
            fontSize: window.innerWidth >= 768 ? '1.25rem' : '1.125rem',
            color: '#d1d5db',
            marginBottom: '48px',
            maxWidth: '512px',
            margin: '0 auto 48px',
            lineHeight: 1.6
          }}
          initial={{ y: 20, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          transition={{ duration: 0.8, delay: 2 }}
        >
          Discover my journey as a Fullstack Engineer specializing in AI-powered solutions,
          cloud architecture, and modern web technologies.
        </motion.p>

        <motion.div
          style={{
            display: 'flex',
            flexDirection: window.innerWidth >= 640 ? 'row' : 'column',
            gap: '16px',
            justifyContent: 'center',
            alignItems: 'center'
          }}
          initial={{ y: 20, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          transition={{ duration: 0.8, delay: 3 }}
        >
          {showContinue ? (
            <motion.button
              onClick={handleContinue}
              style={{
                padding: '12px 32px',
                background: 'linear-gradient(to right, #0ea5e9, #a855f7)',
                color: 'white',
                fontWeight: '600',
                borderRadius: '8px',
                border: 'none',
                cursor: 'pointer',
                transition: 'all 0.3s ease',
                boxShadow: '0 4px 12px rgba(14, 165, 233, 0.3)'
              }}
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.95 }}
            >
              Continue to Portfolio →
            </motion.button>
          ) : (
            <motion.button
              onClick={handleSkip}
              style={{
                padding: '8px 24px',
                color: '#9ca3af',
                background: 'transparent',
                border: 'none',
                cursor: 'pointer',
                transition: 'color 0.3s ease',
                fontSize: '0.875rem'
              }}
              whileHover={{ scale: 1.05 }}
              onMouseEnter={(e) => e.target.style.color = 'white'}
              onMouseLeave={(e) => e.target.style.color = '#9ca3af'}
            >
              Skip intro ⏭
            </motion.button>
          )}
        </motion.div>
      </div>
    </motion.div>
  );
};

export default Splash;